// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** SumUp */
export const SumUp = createBankIcon({
  name: "SumUp",
  slug: "sumup",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"sumup_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,21.1560) scale(0.93700)\">\n    <path d=\"M 57.5,0 H 4.4 C 2,0 0,2 0,4.4 v 52.8 c 0,2.4 2,4.4 4.4,4.4 h 53.1 c 2.4,0 4.4,-2 4.4,-4.4 V 4.4 C 61.9,1.9 59.9,0 57.5,0 Z M 38.8,46.3 c -5.4,5.4 -14,5.6 -19.7,0.7 L 19,46.9 C 18.7,46.6 18.6,46 19,45.6 L 38.2,26.5 c 0.4,-0.3 0.9,-0.3 1.3,0 5,5.8 4.8,14.4 -0.7,19.8 z m 4,-30.5 -19.2,19.1 c -0.4,0.3 -0.9,0.3 -1.3,0 -5,-5.7 -4.8,-14.3 0.6,-19.7 5.4,-5.4 14,-5.6 19.7,-0.7 0,0 0.1,0 0.1,0.1 0.5,0.3 0.5,0.9 0.1,1.2 z\" style=\"fill:#000000\" fill-rule=\"evenodd\" />\n  </g>",
});
